export const allWebinars = [
    {
        uuid: '4bc16cc0-a3db-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/424019067/7ece1b9b73',
        receivers: ['parent'],
        title: 'Mama w pracy - poznaj swoje prawa',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/prawa-mamy-w-pracy.e7ef5a76-05c8-4f39-b48c-8e1e1271fa4d.jpeg',
        description:
            'Kompleksowa rozmowa dotycząca praw matki w miejscu pracy. Skupiamy się głównie na trzech aspektach sytuacyjnych. Pierwszym z nich jest karmienie piersią w miejscu pracy - m.in. jakie przerwy przysługują i jak można je wykorzystać. Drugim aspektem jest prawo do zwolnienia na dziecko - np. czym jest zasiłek opiekuńczy? Wreszcie bierzemy również pod uwagę prawo do do dwóch dni wolnych i zmniejszonego czasu pracy. Po szczegóły zapraszamy na spotkanie!',
        author: {
            name: 'Kinga Lalowicz',
            description:
                'Kinga Lalowicz - prawnik, prezes Fundacji Prawo dla Mam, która pomaga przedsiębiorczym kobietom przetrwać w gąszczu przepisów prawnych. Specjalizuje się w prawie cywilnym, gospodarczym oraz wszelkich sprawach dotyczących obrotu nieruchomościami. Prowadzi fanpage Kinga Lalowicz – Bezpieczny House Flipping.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/kinga-lalowicz.f2bc516d-18b9-4e0b-bd44-d77d6a94d150.jpeg'
        },
        exam: [
            {
                question:
                    'Jak maksymalnie zmniejszyć można wymiar czasu pracy po powrocie z urlopu macierzyńskiego?',
                correct: 'b',
                answers: [
                    {
                        key: 'a',
                        value: 'do 1/3 etatu'
                    },
                    {
                        key: 'b',
                        value: 'do połowy etatu'
                    },
                    {
                        key: 'c',
                        value: 'o godzinę'
                    }
                ]
            }
        ],
        certificate: {
            title: 'Mama w pracy - poznaj swoje prawa',
            description:
                'za uzyskanie prawnych wskazówek dotyczących praw i obowiązków rodzica w miejscu pracy takich jak uzyskanie zasiłku opiekuńczego podczas szkolenia',
            host: 'Kingę Lalowicz'
        }
    },
    {
        uuid: '9201070c-1119-45e3-8402-c663142243ce',
        previewPlaceholder:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/preview.853c3c83-87a4-4e9d-888a-1d11f56bc676.jpeg',
        livestreamvideo_url: 'rzgxyDRnDDI',
        receivers: ['parent'],
        title: 'Dzień dziecka',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/miniaturka.bfc10161-c1c2-4c78-a128-17057a5aa481.jpeg',
        customContent: [
            'Dostęp do wydarzenia na żywo',
            'Dostęp do nagrań po zakończeniu'
        ],
        customDescription: `<h2 id="iluzjonista">ILUZJONISTA</h2>
		<h1 id="krystian-b-czy-ski">Krystian Bączyński</h1>
		<p>Gotowi na magiczne sztuczki? Piłki znikające z jednej dłoni, by zaraz znaleźć się w drugiej? Łączące się w czarodziejski sposób przedmioty, przemieszczające się karty? </p>
		<p>Krystian Bączyński to iluzjonista rodzinny, uznawany za jednego z najlepszych w Polsce. Rozbawi i oczaruje nie tylko Twoje dziecko, ale również całą rodzinę! Duża dawka dobrego humoru, magii oraz iluzji na pewno spodoba się Twojemu dziecku, a Ciebie zabierze do lat dzieciństwa! </p>
		<hr>
		<h2 id="grupa-teatralna-z-krakowa-w-spektaklu">GRUPA TEATRALNA Z KRAKOWA W SPEKTAKLU</h2>
		<h1 id="-ba-dla-ma-ych-akomczuszk-w-tajemnica-zdrowych-brzuszk-w-">„Baśń dla małych łakomczuszków – tajemnica zdrowych brzuszków!"</h1>
		<p>Jak w ciekawy sposób nakłonić dzieci do uprawiania sportu, a także do sięgnięcia po owoce czy warzywa? Zapraszamy wszystkich łakomczuszków na spektakl!</p>
		<p>Królewna Róża jest bardzo dobrą, lecz wstydliwą osobą. Skrzywdzona przez los, musi chować swoją twarz pod maską. Wkrótce Róża ma obchodzić urodziny, a w zamku zjawia się tajemniczy starzec. Oferuje on królewnie pomoc w odzyskaniu pięknego wyglądu, a także opowiada historię sprzed wielu laty…. Czy Róża zdąży wypełnić powierzoną jej misję? </p>
		<hr>
		<h2 id="wyj-tkowe-postacie-z-bajek">WYJĄTKOWE POSTACIE Z BAJEK</h2>
		<h1 id="animaniak">Animaniak</h1>
		<p>Animację w trakcie spotkania poprowadzą dla Was dwie animatorki, w przepięknych i kolorowych przebraniach pań klaun. To jednak nie wszystko! Podopieczni spotkają również Myszkę Miki oraz Bałwanka Olafa.</p>
		<p>Nie zabraknie wyjątkowych zabaw, które możecie wykonywać razem z nami!</p>
		<ul>
		<li>Bajkowy quiz</li>
		<li>Nauka klaunowego tańca Czika-Łaka</li>
		<li>Klaunowa gimnastyka – zabawa z użyciem tabliczek animacyjnych</li>
		<li>Klaunowa przygoda: zaczarowana podróż dookoła świata</li>
		<li>Zabawy z dźwiękiem (przy wykorzystaniu przedmiotów codziennego użytku,które łatwo znaleźć w domu</li>
		</ul>`
    },
    {
        uuid: '35aa8b66-d00d-11ea-87d0-0242ac130003',
        video_url: 'https://vimeo.com/442026757/687309a4b7',
        receivers: ['teacher'],
        title: 'Dzienniczek wakacyjnych wyzwań',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/dzienniczek-wakacyjnych-wyzwan.c1fed0be-d776-4ac3-b110-025e6b168b3a.jpeg',
        description: `W pierwszym odcinku cyklu “Przedszkolne inspiracje na wakacje” przedstawiamy Ci Dzienniczek Wakacyjnych Wyzwań, który przygotowała dla Ciebie Magdalena Tokarczyk. Podczas wakacji zadaniem dzieci będzie wykonanie poszczególnych wyzwań i zadań zawartych na kartach dzienniczka. Podczas kolejnych odcinków udostępnimy Ci również kolejne karty, które wzbogacą i uzupełnią dzienniczek o nowe zadania! W dzisiejszym dowiesz się natomiast, jak rozpocząć przygodę z dzienniczkiem jeśli jesteś wychowawcą oraz rodzicem oraz jak zrealizować pierwsze zadania. Zapraszamy Cię do wspólnej zabawy! Karty do dzienniczka znajdziesz do pobrania za darmo na stronie https://przedszkolankowo.pl/.`,
        author: {
            name: 'Magdalena Tokarczyk',
            description:
                'mama trójki dzieci, w wolnej chwili prowadzi wraz z mężem znany blog przedszkolankowo.pl Prowadzi grupy maluszków, a podczas codziennych zajęć stara się wykorzystywać autorskie postacie jakimi są Bazgrołki. Autorka dwóch projektów edukacyjnych - Przedszkolne Wyzwania Bazgrołków oraz Wielka Księga Zadań Przedszkolaków - które realizuje również w swojej placówce. Na blogu dzieli się z innymi pomysłami na zajęcia, materiałami oraz inspiracjami. Ma głowę pełną pomysłów, a doba ma dla mniej stanowczo za mało godzin na realizację wszystkich!',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/magdalena-tokarczyk.c3bfa09b-8ded-4295-b33b-3489d1f52cad.jpeg'
        }
    },
    {
        uuid: '8af8b9de-cd98-11ea-87d0-0242ac130003',
        cost: 1740,
        video_url: 'https://vimeo.com/441252979/d13231b370',
        receivers: ['teacher'],
        title: 'Porozumienie bez przemocy a sztuka komunikacji',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/porozumienie-bez-przemocy.6695b6dd-6d76-43a6-ad5c-fb7214e7de79.jpeg',
        description:
            'Podczas rozmowy z prelegentką naszym głównym tematem będzie komunikacja poprzez porozumienie bez przemocy. Zastanowimy się nie tylko nad tym, jak możemy pozytywnie wpłynąć na komunikację z dzieckiem, ale również skupimy się na możliwościach komunikacyjnych na linii wychowawca-rodzic. Poznamy najczęstsze błędy, które zdarza nam się popełniać i cenne wskazówki, które możemy wykorzystać na co dzień.',
        author: {
            name: 'Agnieszka Chęcińska-Kopiec',
            description:
                'Nauczyciel akademicki, akredytowany praktyk tutoringu oraz certyfikowany edukator pozytywnej dyscypliny rodziców oraz nauczycieli, edukator self-reg. Pracuje jako nauczyciel akademicki (od 2007 roku); wdraża założenia tutoringu dbając o rozwój i wspierając swoich podopiecznych. Jako potwierdzenie efektów pracy w 2019 roku otrzymała, podczas VII Gali Środowiska Studenckiego Kukucjusze 2019 AWF Katowice, wyróżnienie w kategorii Złote Serce. ',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/agnieszka-checinska-kopiec.62583341-9301-4ef3-a39b-5082f8e003e8.jpeg'
        },
        exam: [
            {
                question:
                    'Które z poniższych należy do błędów komunikacyjnych?',
                correct: 'a',
                answers: [
                    { key: 'a', value: 'Porównywanie dzieci.' },
                    {
                        key: 'b',
                        value:
                            'Wtrącanie w rozmowę wyrażeń typu "mhm", "naprawdę?".'
                    },
                    {
                        key: 'c',
                        value: 'Dzielenie się swoimi spostrzeżeniami.'
                    }
                ]
            }
        ],
        certificate: {
            title: 'Porozumienie bez przemocy a sztuka komunikacji',
            description:
                'za zdobycie wiedzy związanej z wartościową komunikacją z dzieckiem przez porozumienie bez przemocy podczas szkolenia',
            host: 'Agnieszkę Chęcińską-Kopiec'
        }
    },
    {
        uuid: 'c4572d84-c823-11ea-87d0-0242ac130003',
        cost: 1740,
        video_url: 'https://vimeo.com/439185520/7a6b96d31a',
        receivers: ['teacher'],
        title: 'Angielski w przedszkolu',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/angielski-w-przedszkolu.bc7caca5-5b73-49e8-96e1-9785d89fff66.jpeg',
        description:
            'Podczas spotkania poznasz nowe, kreatywne sposoby na naukę języka angielskiego, a także na wykorzystanie sprawdzonych gier i zabaw do przyswajania wiedzy związanej z językiem obcym. Dowiesz się, jak zaciekawić, zaangażować i zmotywować przedszkolaka do nauki angielskiego.',
        author: {
            name: 'Anna Adamska',
            description:
                'Anna Adamska - nauczycielka edukacji wczesnoszkolnej i przedszkolnej, założycielka szkoły językowej Ania z Zielonego Ursynowa, organizatorka licznych warsztatów kreatywnych i stolarskich, ale przede wszystkim mama i pasjonatka mas plastycznych wszelkiego rodzaju.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/anna-adamska.0d36be0d-867e-4cc3-a5ad-b38daadc695b.jpeg"'
        },
        exam: [
            {
                question:
                    'Co możemy zrobić, jeżeli jedno z dzieci w grupie jest bardzo wycofane i ma trudności z przełamaniem się w grupie?',
                correct: 'a',
                answers: [
                    {
                        key: 'a',
                        value:
                            'Poprosić dziecko, aby zostało naszym pomocnikiem w trakcie zajęć.'
                    },
                    {
                        key: 'b',
                        value:
                            'Zignorować dziecko i pozwolić mu samodzielnie odnaleźć się w tempie zajęć.'
                    },
                    {
                        key: 'c',
                        value: 'Porozmawiać z dzieckiem bezpośrednio.'
                    }
                ]
            }
        ],
        certificate: {
            title: 'Angielski w przedszkolu',
            description:
                'za poszerzenie wiedzy dotyczącej kreatywnego nauczania języka angielskiego na zajęciach w przedszkolu podczas szkolenia',
            host: 'Annę Adamską'
        }
    },
    {
        uuid: '39f98c6a-c28b-11ea-b3de-0242ac130004',
        cost: 1740,
        video_url: 'https://vimeo.com/437071191/035339ffcb',
        receivers: ['teacher'],
        title: 'Film animowany w edukacji przedszkolnej',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/film-animowany-w-edukacji-przedszkolnej.479482e8-4e7b-4fc1-85f0-ae80fcac2534.jpeg',
        description:
            'W trakcie spotkania porozmawiamy o możliwościach, jakie w edukacji przedszkolnej stwarza wykorzystanie filmu animowanego. Zastanowimy się również, jak wybierać odpowiednie materiały, aby dzieci mogły uczyć się z nich wartości. Będzie też mowa o wychowywaniu wśród mediów - jak zadbać o to, by te nie miały na dziecko negatywnego wpływu? ',
        author: {
            name: 'Anna Sołowiej',
            description:
                'Anna Sołowiej - w przedszkolu uczy już od 33 lat, ma również za sobą 15 lat doświadczenia jako dyrektor dwóch placówek. Na co dzień zajmuje się terapią pedagogiczną. Interesuje się scrapbookingiem, a wolne chwile spędza w ogrodzie.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/anna-solowiej.e272fe82-c0fa-49c9-a069-6f170ff4516e.jpeg'
        },
        exam: [
            {
                question: 'Od czego powinniśmy rozpocząć ćwiczenia oczu?',
                correct: 'a',
                answers: [
                    { key: 'a', value: 'Od relaksacji całego ciała.' },
                    {
                        key: 'b',
                        value: 'Od wyjścia na zewnątrz.'
                    },
                    {
                        key: 'c',
                        value: 'Od ćwiczeń na koncentrację.'
                    }
                ]
            }
        ],
        certificate: {
            title: 'Film animowany w edukacji przedszkolnej',
            description:
                'za zdobycie wiedzy związanej z wykorzystaniem filmu animowanego oraz bajek w edukacji przedszkolnej podczas szkolenia',
            host: 'Annę Sołowiej'
        }
    },
    {
        uuid: '9c618372-bd0d-11ea-b3de-0242ac130004',
        cost: 1740,
        video_url: 'https://vimeo.com/434993875/b9c0b77e38',
        receivers: ['teacher'],
        title: 'Edukacja aksjologiczna w przedszkolu',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/edukacja-aksjologiczna-w-przedszkolu.5748ce22-d575-4a8a-9520-84bae259ccb3.jpeg',
        description:
            'Podczas spotkania dowiesz się, czym dokładnie jest edukacja aksjologiczna i jaką rolę odgrywa w rozwoju dziecka, które uczęszcza do przedszkola. Z jakimi wartościami stykają się dzieci i jak możemy im pomóc je zrozumieć? Poznasz również wyniki badań naukowych dotyczących edukacji aksjologicznej w polskich przedszkolach.',
        author: {
            name: 'Monika Litwinow',
            description:
                'Monika Litwinow - Prezes Polskiego Towarzystwa Kynoterapeutycznego. Założycielka i Liderka Centrum Terapii i Edukacji BAJARNIA. Redaktor Naczelna Kwartalnika “Zajęcia z Psem”. Nauczyciel akademicki w zakresie tematów związanych z metodyką pracy w terapii i edukacji z psami. Kynoterapeutka, terapeutka terapii behawioralnej, bajkoterapeutka, pedagog.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/monika-litwinow.bf931bc5-2cf7-421f-a865-4f43e6cffb76.jpeg'
        },
        exam: [
            {
                question:
                    'Jakiej wartości zdaniem prelegentki powinno się poświęcić w przedszkolach więcej uwagi?',
                correct: 'b',
                answers: [
                    { key: 'a', value: 'wartości patriotyzmu;' },
                    {
                        key: 'b',
                        value: 'wartości pieniądza;'
                    },
                    {
                        key: 'c',
                        value: 'wartości rodziny.'
                    }
                ]
            }
        ],
        certificate: {
            title: 'Edukacja aksjologiczna w przedszkolu',
            description:
                'za zgłębienie tematyki edukacji aksjologicznej w przedszkolu i poznanie ważnej roli wychowawcy w prowadzeniu dziecka przez świat wartości podczas szkolenia',
            host: 'Monikę Litwinow'
        }
    },
    {
        uuid: 'f7e4a164-a1ad-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/424051940/499ea4cac8',
        receivers: ['teacher'],
        title:
            'Oligofrenopedagogika w zastosowaniu u dzieci z niepełnosprawnością intelektualną',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/oligofrenopedagogika-a-niepelnosprawnosc-intelektualna.fd9b5a2f-9be2-4215-816c-52dfc4b9b734.jpeg',
        description:
            'Dowiedz się, czym dokładnie zajmuje się oligofrenopedagog i jakie kompetencje wchodzą w zakres tej gałęzi pedagogiki. Jak wpływa ona na uczenie dzieci z trudnościami? Jaką rolę odgrywa w pracy z dzieckiem ze spektrum autyzmu? Rozmawiamy również o karach i nagrodach oraz związku oligofrenopedagogiki z rodzicielstwem bliskości.',
        author: {
            name: 'Monika Adamiec',
            description:
                'Monika Adamiec - jest absolwentką Akademii Pedagogiki Specjalnej ze specjalizacją Oligofrenopedagogika. Ukończyła wiele kursów i szkoleń w tym m.in.: w zakresie ruchu rozwijającego bazującego na pracy Weroniki Sherborne, terapii ręki, wstępu do diagnozy i terapii autyzmu, zachowań problemowych u osób z niepełnosprawnością intelektualną i wiele innych. Od ponad 7 lat pracuje z dziećmi wspierając ich rozwój.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/monika-adamiec.982f91ec-4d92-4c57-9574-944fb8fae99d.jpeg'
        },
        exam: [
            {
                question: 'Czym najlepiej zastąpić kary?',
                correct: 'b',
                answers: [
                    { key: 'a', value: 'Nagrodami' },
                    {
                        key: 'b',
                        value: 'Rozmową'
                    },
                    {
                        key: 'c',
                        value: 'Brakiem zainteresowania'
                    }
                ]
            }
        ],
        certificate: {
            title:
                'Oligofrenopedagogika w zastosowaniu u dzieci z niepełnosprawnością intelektualną',
            description:
                'za poszerzenie wiedzy związanej z oligofrenopedagogiką oraz jej znaczeniem i efektami w pracy z dziećmi z niepełnosprawnością intelektualną podczas szkolenia',
            host: 'Monikę Adamiec'
        }
    },
    {
        uuid: 'f7e49f7a-a1ad-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/424016855/55e2528b88',
        receivers: ['teacher'],
        title:
            'Wpływ pracy wewnętrznej na wspieranie dziecka autystycznego w rozwoju',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/rozwoj-dziecka-autystycznego.563f7353-85df-4c7c-9bd2-cc517e673fce.jpeg',
        description:
            'Z jakimi wyzwaniami mierzą się nasi podopieczni ze spektrum autyzmu? Jak rozpoznać jego wczesne objawy? Czym jest trzymanie przestrzeni i proces autoterapeutyczny? Na te i inne pytania odpowiadamy podczas szkolenia. Rozmawiamy jednak także o emocjach opiekunów dzieci ze spektrum autyzmu - z którymi często również niełatwo sobie poradzić.',
        author: {
            name: 'Iwona Wojtasik',
            description:
                'Iwona Wojtasik jestem liderką, przewodniczką i inspiratorką. Jako jedna z pierwszych wraz z Kat Houghton, Małgorzatą Michaluk i Anną Stojanowską wprowadziła do Polski metody i narzędzia oparte na relacji i zabawie w pracy z dziećmi w spektrum autyzmu. Wierzy, że zmiana zaczyna się od nas samych, a zrozumienie relacji i świata wiedzie przez samoświadomość.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/iwona-wojtasik.f6fd249a-91e0-4f1d-8b82-736e40d4e9be.jpeg'
        },
        exam: [
            {
                question:
                    'Czemu tak ważne jest poznanie i zrozumienie etapów rozwoju dziecka?',
                correct: 'a',
                answers: [
                    {
                        key: 'a',
                        value:
                            'Ponieważ wszystkie dzieci przechodzą tę samą ścieżkę rozwojową - zatem znając ją, jesteśmy w stanie zauważyć zmiany i wiedzieć, jak pomóc dziecku.'
                    },
                    {
                        key: 'b',
                        value:
                            'Ponieważ teoria jest podstawą we wspomaganiu w spektrum autyzmu.'
                    },
                    {
                        key: 'c',
                        value:
                            'Ponieważ przez to również poznamy i zrozumiemy sposób myślenia dzieckiem ze spektrum autyzmu.'
                    }
                ]
            }
        ],
        certificate: {
            title:
                'Wpływ pracy wewnętrznej na wspieranie dziecka autystycznego w rozwoju',
            description:
                'za poznanie pojęć i ważnych elementów związanych ze wsparciem w rozwoju dziecka ze spektrum autyzmu podczas szkolenia',
            host: 'Iwonę Wojtasik'
        }
    },
    {
        uuid: 'f7e49a20-a1ad-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/424020325/72391e5199',
        receivers: ['teacher'],
        title:
            'Budowanie relacji z dzieckiem w spektrum autyzmu poprzez zabawę',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/spektrum-autyzmu-a-zabawa.446b0f7f-126c-4ade-9696-f8301e334e64.jpeg',
        description:
            'Z jakimi wyzwaniami mierzą się nasi podopieczni ze spektrum autyzmu? Kolejne spotkanie z naszą prelegentką zwraca uwagę na proces budowania relacji jako niezwykle istotny element życia dziecka w spektrum autyzmu. Szczególnie ważną rolę odgrywa w nim zabawa, której również poświęcamy podczas szkolenia wiele uwagi.',
        author: {
            name: 'Iwona Wojtasik',
            description:
                'Iwona Wojtasik jestem liderką, przewodniczką i inspiratorką. Jako jedna z pierwszych wraz z Kat Houghton, Małgorzatą Michaluk i Anną Stojanowską wprowadziła do Polski metody i narzędzia oparte na relacji i zabawie w pracy z dziećmi w spektrum autyzmu. Wierzy, że zmiana zaczyna się od nas samych, a zrozumienie relacji i świata wiedzie przez samoświadomość.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/iwona-wojtasik.f6fd249a-91e0-4f1d-8b82-736e40d4e9be.jpeg'
        },
        exam: [
            {
                question:
                    'Jakie zachowania opiekunów nie wspierają relacji dziecka w spektrum autyzmu?',
                correct: 'a',
                answers: [
                    {
                        key: 'a',
                        value:
                            'Zwrócenie uwagi na to, czy dziecko jest gotowe na środowisko, w którym się znajduje.'
                    },
                    {
                        key: 'b',
                        value:
                            'Obserwacja dziecka i świadomość etapu rozwojowego, na jakim się znajduje.'
                    },
                    {
                        key: 'c',
                        value: 'Wprowadzenie dziecka do grupy starszych dzieci.'
                    }
                ]
            }
        ],
        certificate: {
            title:
                'Budowanie relacji z dzieckiem w spektrum autyzmu poprzez zabawę',
            description:
                'za poznanie zależności pomiędzy rolą zabawy a rozwojem dziecka ze spektrum autyzmu i akcentem na budowanie relacji podczas szkolenia',
            host: 'Iwonę Wojtasik'
        }
    },
    {
        uuid: '21b4b456-9c0a-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/421497004/2b2476cf46',
        receivers: ['teacher'],
        title:
            'Zabawki handmade oraz organizacja i zalety zabaw paluszkowych w żłobku i przedszkolu',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/dobroslawa-min.7df83bcf-6efd-4d2a-829c-70c232790558.jpeg',
        description:
            'Podczas spotkania dowiesz się, jakie są cele zabaw paluszkowych w żłobku oraz jakie plusy niesie wykonywanie zabawek handmade. Zobaczysz przykłady wykonania takich zabawek oraz przykłady zabaw metodą paluszkową, które możesz wykorzystać w trakcie własnych zajęć.',
        author: {
            name: 'Dobrosława Horbacz',
            description:
                'Dobrosława Horbacz - jest czynną opiekunką z 40-letnim stażem pracy. Zawodowo również szkoli ciocie i nauczycielki w temacie Zabaw paluszkowych, masażyków, piosenek z pokazywaniem. Promuje wykorzystywanie materiałów recyklingowych w pracach plastycznych. Prowadzi stronę Paluszkowe Rozśpiewanki, na której dzieli się swoimi pomysłami.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/dobroslawa-horbacz.bbb8c1c1-d425-4fa5-83a4-e125cde85e64.jpeg'
        },
        exam: [
            {
                question:
                    'Co według prelegentki jest najlepszym efektem zabaw paluszkowych?',
                correct: 'a',
                answers: [
                    { key: 'a', value: 'Uśmiech dziecka' },
                    {
                        key: 'b',
                        value: 'Odstresowanie'
                    },
                    {
                        key: 'c',
                        value: 'Rozwój ruchowy'
                    }
                ]
            }
        ],
        certificate: {
            title:
                'Zabawki handmade oraz organizacja i zalety zabaw paluszkowych w żłobku i przedszkolu',
            description:
                'za poznanie roli zabaw paluszkowych w żłobku, oraz zdobycie praktycznych inspiracji do prowadzenia zajęć tą metodą, a także tworzenia zabawek handmade podczas szkolenia',
            host: 'Dobrosławę Horbacz'
        }
    },
    {
        uuid: '6fb081aa-9686-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/418808430/a0e845958c',
        receivers: ['parent'],
        title: 'Funkcje zabawy oraz bajkoterapii w rozwoju dziecka”',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/marta-min.7dac7082-e957-4f25-bc5c-e3d3401693e0.jpeg',
        description:
            'Podczas spotkania poznasz etapy zabawy w rozwoju dziecka i jej poszczególne funkcje, które mają ogromne znaczenie w poznawaniu przez dziecko otaczającej je rzeczywistości. Omawiamy także znaczenie bajkoterapii, podpowiadając, jak stworzyć i opowiadać bajkę terapeutyczną. Skupiamy się także na roli zabawy i bajkoterapii w procesie adaptacji dziecka.',
        author: {
            name: 'Marta Chrościcka',
            description:
                'Marta Chrościcka - psycholog, diagnostka kliniczna, terapeutka rodzinna. Absolwentka psychologii społecznej Uniwersytetu SWPS w Warszawie. Uzyskała specjalizację w diagnozie psychologicznej w praktyce klinicznej. Obecnie psychoterapeutka rodzinna w trakcie szkolenia. Współpracuje z pięcioma przedszkolami jako psycholog wspierający. Posiada Certyfikat Bajkoterapeutki klinicznej. Ukończyła m.in. warsztaty/szkolenia z zakresu: neurologicznych podstaw zachowania dzieci oraz zabawy jako forma terapii.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/marta-chroscicka.3b4372af-cd5b-410a-a46a-9994aa3df8c8.jpeg'
        },
        exam: [
            {
                question: 'Czy bajki terapeutyczne można tworzyć samemu?',
                correct: 'c',
                answers: [
                    {
                        key: 'a',
                        value: 'Tak, każda bajka nosi znamiona terapeutycznej.'
                    },
                    {
                        key: 'b',
                        value: 'Nie, tylko specjaliści mogą je tworzyć.'
                    },
                    {
                        key: 'c',
                        value:
                            'Tak, ale nie powinny one zawierać nierealnych rozwiązań problemu.'
                    }
                ]
            }
        ],
        certificate: {
            title: 'Funkcje zabawy oraz bajkoterapii w rozwoju dziecka”',
            description:
                'za poznanie roli i funkcji zabawy na poszczególnych etapach rozwoju dziecka oraz charakterystyki tworzenia bajek terapeutycznych podczas szkolenia',
            host: 'Martę Chrościcką'
        }
    },
    {
        uuid: '790e3b18-9521-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/418793411/a882af3f7b',
        receivers: ['parent'],
        title:
            'Wspieranie prawidłowego rozwoju dziecka i zaburzenia przetwarzania sensorycznego',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/joanna-min.ef18655d-d79b-449e-92b6-478d0eff3d60.jpeg',
        description:
            'Dowiedz się, jak możesz wspierać rozwój sensoryczny dziecka! Rozmawiamy o stymulacji procesów sensorycznych, zaburzeniach rozwoju i sposobach na domowe ćwiczenia sensoryczne. Poznaj podział systemów sensorycznych, pojęcie małej motoryki oraz nadwrażliwości lub podwrażliwości systemów. Dowiedz się, co powinno zwrócić Twoją uwagę oraz jakich sygnałów rozwojowych wypatrywać.',
        author: {
            name: 'Joanna Chomicz-Wlazły',
            description:
                'Joanna Chomicz-Wlazły - założycielka strony Fizjoterapeutycznie. Specjalizuje się m.in. w konsultacjach fizjoterapeutycznych, diagnostyce neurorozwojowej niemowląt, diagnozie oraz terapii integracji sensorycznej oraz terapii ręki.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/joanna-chomicz-wlazly.fd363c51-175c-49b8-b41e-9ac819f43443.jpeg'
        },
        exam: [
            {
                question:
                    'Powodem, dla którego dziecko może nie chcieć być dotykane przez rówieśników jest...?',
                correct: 'c',
                answers: [
                    {
                        key: 'a',
                        value: 'Zaburzenia sensoryczne.'
                    },
                    {
                        key: 'b',
                        value: 'Nadpobudliwość.'
                    },
                    {
                        key: 'c',
                        value: 'Nadwrażliwość dotykowa.'
                    }
                ]
            }
        ],
        certificate: {
            title:
                'Wspieranie prawidłowego rozwoju dziecka i zaburzenia przetwarzania sensorycznego',
            description:
                'za zdobycie wiedzy dotyczącej stymulacji procesów sensorycznych i ich podziału, a także wspierania rozwoju dziecka podczas szkolenia',
            host: 'Joannę Chomicz-Wlazły'
        }
    },
    {
        uuid: '6fb07dd6-9686-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/418806551/c7da98302c',
        receivers: ['parent'],
        title:
            'Planowanie pełnowartościowej diety dziecka – na co zwrócić uwagę?',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/aleksandra-min.18616327-bd45-49fc-bbab-7d514da4112b.jpeg',
        description:
            'Czy masz pewność, że dieta Twojego dziecka zawiera wszystko to, co powinna? Naucz się planować dietę, która dostarczy dziecku odpowiednie składniki spożywcze. Dowiedz się, czego unikać, a czego organizm dziecka potrzebuje szczególnie mocno w okresie rozwojowym. Podpowiadamy również w jakich produktach szukać konkretnych witamin i minerałów, niezbędnych do prawidłowego funkcjonowania.',
        author: {
            name: 'Aleksandra Kucharczyk',
            description:
                'Aleksandra Kucharczyk - dietetyk kliniczny i coach. Uczestniczy w konferencjach, szkoleniach oraz jest na bieżąco z najnowszą literaturą healthcare. Sukcesywnie łączy teorię z praktyką. Doświadczenie zdobyła prowadząc własną poradnię, współpracując z krakowskimi gabinetami oraz prowadząc zajęcia z zakresu żywienia dla firm.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/aleksandra-kucharczyk.dd802144-dbb9-4c81-a216-b2a844120b31.jpeg'
        },
        exam: [
            {
                question:
                    'Jaki jest dobry sposób na wprowadzanie nowych produktów do diety dziecka (np. kiszonek)?',
                correct: 'b',
                answers: [
                    {
                        key: 'a',
                        value: 'Podawanie ich przez cały dzień, aż do skutku'
                    },
                    {
                        key: 'b',
                        value: 'Mieszanie ich z potrawami, które dziecko zna.'
                    },
                    {
                        key: 'c',
                        value: 'Dawanie dziecku nagród za zjedzoną nowość.'
                    }
                ]
            }
        ],
        certificate: {
            title:
                'Planowanie pełnowartościowej diety dziecka – na co zwrócić uwagę?',
            description:
                'za zdobycie wiedzy związanej z kompleksowym planowaniem diety dziecka z uwzględnieniem odpowiednich składników spożywczych podczas szkolenia',
            host: 'Aleksandrę Kucharczyk'
        }
    },
    {
        uuid: '790e3898-9521-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/418046652/9ff02b2e84',
        receivers: ['parent'],
        title: 'Rozszerzanie diety dziecka od 0 do 6 lat',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/anna-min.671ab277-4d91-47ef-ba30-42f798886972.jpeg',
        description:
            'Dobrze zbilansowana dieta to podstawa - dlatego podczas spotkania omawiamy proces rozszerzania diety dziecięcej wspierającej rozwój maluchów i starszych dzieci. Definiujemy dietę BLW i omawiamy każdy etap rozszerzania diety malucha od najmłodszych lat. Skupiamy również uwagę na niektórych faktach i mitach krążących wokół tematu żywienia dzieci.',
        author: {
            name: 'Anna Patrzałek',
            description:
                'Anna Patrzałek - założycielka strony Dylematy Mamy i Taty, na której porusza tematy związane ze zdrowym żywieniem i rozszerzaniem diety dziecięcej. Edukatorka Żywieniowa programu Zdrowo Jemy Zdrowo Rośniemy,  dietetyczka w Przedszkolu Samorządowym w Krakowie oraz członkini Polskiego Towarzystwa Dietetyki.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/anna-patrzalek.90aea0e7-8e05-4459-b3e1-ec83c9b78d74.jpeg'
        },
        exam: [
            {
                question:
                    'Zaznacz BŁĘDNĄ odpowiedź: dlaczego ważne jest, by nie przesadzać z solą w dziecięcych potrawach?',
                correct: 'c',
                answers: [
                    {
                        key: 'a',
                        value: 'Ponieważ jest niezdrowa.'
                    },
                    {
                        key: 'b',
                        value: 'Ponieważ dziecko przyzwyczaja się do jej smaku.'
                    },
                    {
                        key: 'c',
                        value: 'Ponieważ lepiej zastąpić ją substytutami soli.'
                    }
                ]
            }
        ],
        certificate: {
            title: 'Rozszerzanie diety dziecka od 0 do 6 lat',
            description:
                'za uzyskanie wskazówek dotyczących rozszerzania diety dziecka na każdym etapie oraz poznanie metody BLW podczas szkolenia',
            host: 'Annę Patrzałek'
        }
    },
    {
        uuid: '54e5c6e4-9115-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/416290539/87b3a70c8d',
        receivers: ['teacher'],
        title: 'Joga dla dzieci i rozwój w przedszkolu – męski punkt widzenia',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/joga.51410041-95ed-4f9a-a692-08c06f92adab.jpeg',
        description:
            'Jak prowadzić zajęcia z jogi w przedszkolu, i jak wykorzystać te inspiracje w zaciszu domowym? Szkolenie dotyczące jogi w przedszkolu, jej pozytywnych skutków i ciekawostek z nią związanych. Dodatkowo rozmawiamy również o elementach rozwoju dziecka i wspieraniu kreatywności na etapie przedszkola.',
        author: {
            name: 'Beniamin Kweclich',
            description:
                'Beniamin Kweclich - założyciel znanego profilu na Instagramie “Facet w przedszkolu” instruktor jogi dla dzieci, nauczyciel wychowania przedszkolnego oraz psycholog.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/beniamin-kweclich.236934f8-f87f-4b07-a583-8292ffb6ac19.jpeg'
        },
        exam: [
            {
                question: 'Czy każdy może zapisać się na kurs jogi dla dzieci?',
                correct: 'b',
                answers: [
                    { key: 'a', value: 'Nie' },
                    {
                        key: 'b',
                        value: 'Tak'
                    },
                    {
                        key: 'c',
                        value: 'Zależy od długości trwania kursu'
                    }
                ]
            }
        ],
        certificate: {
            title:
                'Joga dla dzieci i rozwój w przedszkolu – męski punkt widzenia',
            description:
                'za zdobycie wiedzy dotyczącej prowadzenia zajęć z jogi w przedszkolu i kreatywnego rozwoju za ich pomocą podczas szkolenia',
            host: 'Beniamina Kweclicha'
        }
    },
    {
        uuid: '4ef76384-903c-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/415830282/ffff87993d',
        receivers: ['teacher'],
        title: 'Zaburzenia mowy u dzieci – profilaktyka i terapia logopedyczna',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/webinar-.7f3d0d0a-f54c-4b4b-b719-e3efb909abf4.jpeg',
        description:
            'Wraz z naszą prelegentką nauczysz się rozpoznawania prawidłowo następujących po sobie etapów rozwoju mowy dziecka. Zwrócimy uwagę na symptomy niepokojące i doradzimy, jak na nie reagować. Dowiesz się również, jak wspierać rozwój mowy od najmłodszych lat i poznasz odpowiedzi na najczęściej zadawane pytania w tym aspekcie.',
        author: {
            name: 'Paulina Mistal',
            description:
                'Logopeda, naukowiec, organizatorka wielu akcji społecznych o zasięgu ogólnokrajowym, współzałożycielka komitetu społecznego na rzecz ustawy o zawodzie logopedy, członek organizacji logopedycznych. Prowadzi na Facebooku znany profil pod nazwą Pani Logopedyczna, na którym dzieli się swoją wiedzą i doświadczeniem.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/paulina-mistal.88099112-5648-401f-aa86-a603972f67c8.jpeg'
        },
        exam: [
            {
                question:
                    'Na co warto zwrócić uwagę przy doborze książeczki do czytania dla dziecka?',
                correct: 'a',
                answers: [
                    {
                        key: 'a',
                        value:
                            'Dać mu wybór pomiędzy dwoma różnymi, dopasować do zainteresowań.'
                    },
                    {
                        key: 'b',
                        value:
                            'Na wielkość literek i obszerność tekstu w książeczce.'
                    },
                    {
                        key: 'c',
                        value:
                            'Na ilustracje - czy są kolorowe i dopasowane do tematyki.'
                    }
                ]
            }
        ],
        certificate: {
            title:
                'Zaburzenia mowy u dzieci – profilaktyka i terapia logopedyczna',
            description:
                'za zdobycie wiedzy związanej z rozpoznawaniem i reagowaniem na symptomy zaburzeń mowy u dzieci podczas szkolenia',
            host: 'Paulinę Mistal'
        }
    },
    {
        uuid: '4ef76230-903c-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/415830027/e377ead7a9',
        receivers: ['teacher'],
        title:
            'Przedszkolne wyzwania do opanowania – inspiracje dla rodziców i wychowawców',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/webinar-.6e99da9c-d3ff-4d94-bd62-9a9efd2060ae.jpeg',
        description:
            'Podczas spotkania odpowiadamy na pytanie, jak mądrze stawiać dziecku wyzwania i jakie są tego zalety. Definiujemy wyzwania na różnych etapach rozwoju dziecka i szukamy pomysłów na kreatywne mierzenie się z nimi. Dowiesz się również, jak zorganizować ciekawe zajęcia, zaangażować rodziców i dzieci oraz jak sprawić, by praca zdalna była dla nas komfortowa.',
        author: {
            name: 'Magdalena Tokarczyk',
            description:
                'Magdalena Tokarczyk - autorka strony przedszkolankowo.pl. Na swoim blogu dzieli się z innymi pomysłami na zajęcia, oraz materiałami które można wykorzystać podczas codziennej pracy z dziećmi.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/magdalena-tokarczyk.c3bfa09b-8ded-4295-b33b-3489d1f52cad.jpeg'
        },
        exam: [
            {
                question:
                    'Jak nazywają się stworki prezentowane na spotkaniu, które mogą pomóc dziecku zrozumieć emocje?',
                correct: 'b',
                answers: [
                    { key: 'a', value: 'Supełki' },
                    { key: 'b', value: 'Bazgrołki' },
                    { key: 'c', value: 'Pętelki' }
                ]
            }
        ],
        certificate: {
            hidden: true,
            title:
                'Przedszkolne wyzwania do opanowania – inspiracje dla rodziców i wychowawców',
            description:
                'za uzyskanie szeregu wiadomości i inspiracji związanych ze stawianiem dziecku mądrych wyzwań na różnych etapach rozwoju podczas szkolenia',
            host: 'Magdalenę Tokarczyk'
        }
    },
    {
        uuid: '01b2f572-9373-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/417193052/d414d77a4f',
        receivers: ['teacher'],
        title: 'Pozytywna Dyscyplina w edukacji wczesnoszkolnej',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/sylw1.61623835-15f5-42fc-bbae-d82d67d52803.jpeg',
        description:
            'Poznaj założenia Pozytywnej Dyscypliny, które możesz wykorzystać w swojej placówce wczesnoszkolnej, lub podczas zabawy z dziećmi w domu. Zasady Pozytywnej Dyscypliny oraz wyjaśnienie korzyści z niej płynących pomogą Ci wprowadzić metodę w swoim domu lub placówce. Dowiedz się, od czego zacząć, jak dzięki Pozytywnej Dyscyplinie pomóc dzieciom odkrywać talenty, rozwiązywać konflikty i budować więzi społeczne.',
        author: {
            name: 'Sylwia Anderson-Hanney',
            description:
                'Jest profilaktykiem społecznym oraz jedynym w Polsce certyfikowanym trenerem Pozytywnej Dyscypliny dla rodziców oraz nauczycieli. Jako członek Positive Discipline Association dba o merytorykę i jakość przeprowadzanych w Polsce warsztatów i szkoleń. Specjalizuje się w pracy z rodziną, w której wykorzystuje wiedzę i umiejętności pedagoga, terapeuty, coacha oraz mediatora.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/sylwia-anderson-hanney.a0ebcbff-c804-4278-977c-2a42a4e0764c.jpeg'
        },
        exam: [
            {
                question: '4R kary to inaczej:',
                correct: 'c',
                answers: [
                    {
                        key: 'a',
                        value: 'Cztery zasady formułowania kary dla dziecka.'
                    },
                    {
                        key: 'b',
                        value:
                            'Sposoby na wyznaczenie kary, która będzie skuteczna.'
                    },
                    {
                        key: 'c',
                        value: 'Główne konsekwencje stosowania kar.'
                    }
                ]
            }
        ],
        certificate: {
            title: 'Pozytywna Dyscyplina w edukacji wczesnoszkolnej',
            description:
                'za uzyskanie definicji i wskazówek do stosowania metody Pozytywnej Dyscypliny w edukacji przedszkolnej i wczesnoszkolnej podczas szkolenia',
            host: 'Sylwię Anderson-Hanney'
        }
    },
    {
        uuid: '881de880-9038-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/415899108/f5c74ed678',
        receivers: ['teacher'],
        title: 'Praca zdalna z rodzicami - sposoby na motywację i organizację ',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/webinar-.0d86a00f-cabb-442b-9fe1-46514e105744.jpeg',
        description:
            'Czego dowiesz się podczas szkolenia? Z jakich rozwiązań w pracy zdalnej możesz skorzystać bez opłat? Jakie źródła online warto znać? Jak się zmotywować do efektywnej pracy zdalnej tak, by była również komfortowa dla Ciebie? Jak najłatwiej zorganizować i zaplanować przebieg zdalnej edukacji dla rodziców i dzieci?',
        author: {
            name: 'Gabriela Fejkiel',
            description:
                'Gabriela Fejkiel - trenerka, absolwentka pedagogiki przedszkolnej i wczesnoszkolnej, dyrektor ds. pedagogicznych w przedszkolu, edukator II stopnia Froebel.pl, magister pedagogiki przedszkolnej i wczesnoszkolnej, absolwentka studiów doktoranckich z pedagogiki na Dolnośląskiej Szkole Wyższej we Wrocławiu.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/gabriela-fejkiel.f6bd5c98-f289-4b6c-a366-3cf7525cef3e.jpeg'
        },
        exam: [
            {
                question:
                    'Co jest według prelegentki najważniejsze podczas wykonywania pracy zdalnej?',
                correct: 'b',
                answers: [
                    { key: 'a', value: 'Odcięcie się od zbędnych bodźców' },
                    { key: 'b', value: 'Sporządzenie dobrego planu pracy' },
                    { key: 'c', value: 'Spontaniczność i dynamika pracy' }
                ]
            }
        ],
        certificate: {
            title:
                'Praca zdalna z rodzicami - sposoby na motywację i organizację ',
            description:
                'za poszerzenie informacji związanych z planowaniem, organizowaniem i motywowaniem się do pracy zdalnej podczas szkolenia',
            host: 'Gabrielę Fejkiel'
        }
    },
    {
        uuid: '01b2f00e-9373-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/417151287/6a14544721',
        receivers: ['teacher'],
        title: 'Pozytywna Dyscyplina w edukacji przedszkolnej',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/webinar-.1cd427e8-8ef5-4e0a-bdd2-2634852cb62f.jpeg',
        description:
            'Poznaj założenia Pozytywnej Dyscypliny, które możesz wykorzystać w swojej placówce. Dowiedz się, od czego zacząć, jak dzięki Pozytywnej Dyscyplinie pomóc dzieciom odkrywać talenty, rozwiązywać konflikty i budować więzi społeczne. Zyskaj od prelegentki cenne wskazówki zdobyte przez doświadczenie, które podpowiedzą Ci, jak działać i jakich błędów unikać.',
        author: {
            name: 'Sylwia Anderson-Hanney',
            description:
                'Jest profilaktykiem społecznym oraz jedynym w Polsce certyfikowanym trenerem Pozytywnej Dyscypliny dla rodziców oraz nauczycieli. Jako członek Positive Discipline Association dba o merytorykę i jakość przeprowadzanych w Polsce warsztatów i szkoleń. Specjalizuje się w pracy z rodziną, w której wykorzystuje wiedzę i umiejętności pedagoga, terapeuty, coacha oraz mediatora.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/sylwia-anderson-hanney.a0ebcbff-c804-4278-977c-2a42a4e0764c.jpeg'
        },
        exam: [
            {
                question: 'Przed czym ostrzega prelegentka podczas spotkania?',
                correct: 'a',
                answers: [
                    {
                        key: 'a',
                        value:
                            'Pozytywna Dyscyplina nie może zacząć się tylko od książek i teorii, lecz od własnego podejścia.'
                    },
                    {
                        key: 'b',
                        value:
                            'Przed negatywnymi skutkami, które może wywołać stosowanie Pozytywnej Dyscypliny.'
                    },
                    {
                        key: 'c',
                        value:
                            'Przed aspektami Pozytywnej Dyscypliny, na które na początku nie warto zwracać uwagi.'
                    }
                ]
            }
        ],
        certificate: {
            title: 'Pozytywna Dyscyplina w edukacji przedszkolnej',
            description:
                'za rozszerzenie wiedzy związanej z metodą Pozytywnej Dyscypliny w edukacji przedszkolnej i zdobycie cennych wskazówek do jej wprowadzania podczas szkolenia',
            host: 'Sylwię Anderson-Hanney'
        }
    },
    {
        uuid: '4ef757ea-903c-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/415829849/124f412fc0',
        receivers: ['parent'],
        title:
            'Dlaczego dzieci gryzą, biją i się złoszczą? Wspieramy w emocjach',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/webinar-.2a2157d8-7aa2-4432-b8ce-6996b77c70e0.jpeg',
        description:
            'Dlaczego dzieci gryzą, biją i się złoszczą? Czy istnieje uniwersalna odpowiedź na takie pytanie? Dowiedz się, co możesz zrobić, by złe emocje występowały rzadziej. Rozmawiamy o agresywnych zachowaniach, upartym “nie” ze strony dziecka oraz napadach złości. Nasza prelegentka pomoże zrozumieć te sytuacje i nauczy Cię odpowiednio na nie reagować.',
        author: {
            name: 'Aleksandra Iwacz',
            description:
                'Aleksandra Iwacz to psycholog, terapeuta pedagogiczny, trener umiejętności społecznych i sensoplastyki, ale przede wszystkim również mama. Jest zafascynowana psychologią dziecka, rodziny i relacjami.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/aleksandra-iwacz.8f0c0ceb-ac1c-4c9c-90da-46d20289a133.jpeg'
        },
        exam: [
            {
                question:
                    'Co może pomóc wychowawcy w placówce w budowaniu współpracy u dzieci?',
                correct: 'c',
                answers: [
                    {
                        key: 'a',
                        value:
                            'Konkretna prośba o poprawę zachowania w tym względzie.'
                    },
                    {
                        key: 'b',
                        value:
                            'Rozmowa z rodzicami, którzy wpływają na dziecko w domu.'
                    },
                    {
                        key: 'c',
                        value:
                            'Zdobycie zaufania dziecka, upewnienie go w tym, że jest zauważane i doceniane.'
                    }
                ]
            }
        ],
        certificate: {
            title:
                'Dlaczego dzieci gryzą, biją i się złoszczą? Wspieramy w emocjach',
            description:
                'za zdobycie wiedzy na temat reagowania na złe emocje oraz wspierania dzieci w ich zrozumieniu podczas szkolenia',
            host: 'Aleksandrę Iwacz'
        }
    },
    {
        uuid: 'd5a6f44a-913a-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/416357534/2d0f698b75',
        receivers: ['parent'],
        title: 'Czy rozumiemy nasze dzieci? Sztuka dostrzegania problemu',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/agn.babb325a-7efb-4861-9157-b959725ec75c.jpeg',
        description:
            'Czy zawsze rozumiesz, co Twoje dziecko chce Ci przekazać? Wspólnie nauczymy się rozpoznawać, nazywać i rozwiązywać dziecięce problemy. Poznamy punkt widzenia Jespera Juula i wizję wychowania opartą na jego książce. Jakie sygnały dzieci trzeba być wyczulonym? Jak interpretować te zachowania? Sztuka komunikacji pomoże nam rozmawiać i budować więź z dzieckiem. Rozmawiamy też o kilku najczęściej popełnianych w tym aspekcie błędów.',
        author: {
            name: 'Agnieszka Chęcińska-Kopiec',
            description:
                'Nauczyciel akademicki, akredytowany praktyk tutoringu oraz certyfikowany edukator pozytywnej dyscypliny rodziców oraz nauczycieli, edukator self-reg. Pracuje jako nauczyciel akademicki (od 2007 roku); wdraża założenia tutoringu dbając o rozwój i wspierając swoich podopiecznych. Jako potwierdzenie efektów pracy w 2019 roku otrzymała, podczas VII Gali Środowiska Studenckiego Kukucjusze 2019 AWF Katowice, wyróżnienie w kategorii Złote Serce.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/agnieszka-checinska-kopiec.62583341-9301-4ef3-a39b-5082f8e003e8.jpeg'
        },
        exam: [
            {
                question: 'Na czym polega aktywne słuchanie?',
                correct: 'b',
                answers: [
                    {
                        key: 'a',
                        value:
                            'Słuchanie podczas czynności fizycznych, np. gotowania obiadu.'
                    },
                    {
                        key: 'b',
                        value:
                            'Nawiązanie kontaktu wzrokowego, odłożenie telefonu, reagowanie na komunikat.'
                    },
                    {
                        key: 'c',
                        value:
                            'Na pozwoleniu dziecku “wygadać się”, bez reakcji zwrotnej.'
                    }
                ]
            }
        ],
        certificate: {
            title: 'Czy rozumiemy nasze dzieci? Sztuka dostrzegania problemu',
            description:
                'za poznanie sposobów na rozwiązywanie problemów z punktu widzenia Jespera Juula oraz interpretacji trudnych zachowań dziecka podczas szkolenia',
            host: 'Agnieszkę Chęcińską-Kopiec'
        }
    },
    {
        uuid: '4ef76488-903c-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/415830376/353f1d36a2',
        receivers: ['parent'],
        title: 'Wychowanie wspierające przez pozytywną komunikację',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/webinar-.bfc850b3-b5a2-42c4-9ea0-1bece06921fd.jpeg',
        description:
            'Jak odnaleźć się w gąszczu metod wychowawczych? Czy istnieją takie, które są całkowicie uniwersalne? Czym się charakteryzuje pozytywna komunikacja? Na te i wiele innych pytań udzielamy odpowiedzi podczas spotkania z Anną Jankowską. Uczymy się wspierać dzieci w radzeniu sobie w trudnych emocjach, nowych sytuacjach i współpracy.',
        author: {
            name: 'Anna Jankowska',
            description:
                'Anna Jankowska jest pedagogiem, autorką książek dla dzieci i rodziców. Prowadzi blog i nagrywa podcast Tylko dla Mam, gdzie rozmawia o wychowaniu wspierającym i komunikacji w rodzinie. Drugi blog to Aktywne Czytanie oraz podcast Aktywne Czytanie – książki dla dzieci. Jej założeniem jest wspieranie czytelnictwa, opowiada o mądrych i rozwijających książkach dla dzieci.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/anna-jankowska.ef45c37d-aa2d-4537-a32b-481b2ecf9150.jpeg'
        },
        exam: [
            {
                question: 'Im więcej kar...',
                correct: 'a',
                answers: [
                    {
                        key: 'a',
                        value:
                            'tym trudniej dziecku przestać uczyć się, jak uniknąć kary w przyszłości.'
                    },
                    {
                        key: 'b',
                        value: 'tym rzadsze są przypadki dziecięcego buntu.'
                    },
                    {
                        key: 'c',
                        value: 'tym łatwiej nam budować relację z dzieckiem.'
                    }
                ]
            }
        ],
        certificate: {
            hidden: true,
            title: 'Wychowanie wspierające przez pozytywną komunikację',
            description:
                'za zdobycie wiedzy dotyczącej metody pozytywnej komunikacji - jej założeń, skutków oraz działania w trudnych sytuacjach podczas szkolenia',
            host: 'Annę Jankowską'
        }
    },
    {
        uuid: '3cc3fd3e-9065-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/415924784/697985fb6a',
        receivers: ['parent'],
        title: 'Minimediacje – jak być częścią rozwiązania, a nie konfliktu',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/webinar-.83a132d0-5dc7-4c57-8eda-c233b83fdbb4.jpeg',
        description:
            'Podczas spotkania poznasz strategię minimediacji, która pomoże Ci znaleźć rozwiązanie konfliktów, zamiast stawać się ich częścią. Dowiedz się, skąd wywodzą się minimediacje, jak je przeprowadzić oraz jakich efektów możesz się spodziewać.',
        author: {
            name: 'Agnieszka Chęcińska-Kopiec',
            description:
                'Nauczyciel akademicki, akredytowany praktyk tutoringu oraz certyfikowany edukator pozytywnej dyscypliny rodziców oraz nauczycieli, edukator self-reg. Pracuje jako nauczyciel akademicki (od 2007 roku); wdraża założenia tutoringu dbając o rozwój i wspierając swoich podopiecznych. Jako potwierdzenie efektów pracy w 2019 roku otrzymała, podczas VII Gali Środowiska Studenckiego Kukucjusze 2019 AWF Katowice, wyróżnienie w kategorii Złote Serce.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/agnieszka-checinska-kopiec.62583341-9301-4ef3-a39b-5082f8e003e8.jpeg'
        },
        exam: [
            {
                question:
                    'Jakie etapy pomocnicze rozwiązania konfliktu proponuje prelegentka?',
                correct: 'b',
                answers: [
                    { key: 'a', value: 'Rozumiem, nazywam, zarządzam' },
                    { key: 'b', value: 'Słyszę/widzę, nazywam, otwieram' },
                    { key: 'c', value: 'Słyszę/widzę, nazywam, zarządzam' }
                ]
            }
        ],
        certificate: {
            title:
                'Minimediacje – jak być częścią rozwiązania, a nie konfliktu',
            description:
                'za zdobycie wiedzy związanej z planowaniem, przeprowadzaniem i wykorzystywaniem techniki minimediacji w relacjach z dzieckiem podczas szkolenia',
            host: 'Agnieszkę Chęcińską-Kopiec'
        }
    },
    {
        uuid: '37efe066-913c-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/416432820/bedff62f4d',
        receivers: ['parent'],
        title: 'Odkrywamy mocne strony dzieci. Sztuka wzmacniania',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/agn.2f27cb17-50bd-4382-9da1-ef78b32bbf64.jpeg',
        description:
            'Wiemy doskonale, że na pewno ważne jest dla Ciebie wspieranie dzieci - niezależnie od tego, czy jesteś rodzicem, czy też wychowawcą. Na tym spotkaniu nauczysz się odkrywać mocne strony podopiecznych, a następnie wzmacniać je i pogłębiać. Dzięki zdobytej wiedzy pomożesz dziecku rozwijać unikalne talenty oraz kompetencje.',
        author: {
            name: 'Agnieszka Chęcińska-Kopiec',
            description:
                'Nauczyciel akademicki, akredytowany praktyk tutoringu oraz certyfikowany edukator pozytywnej dyscypliny rodziców oraz nauczycieli, edukator self-reg. Pracuje jako nauczyciel akademicki (od 2007 roku); wdraża założenia tutoringu dbając o rozwój i wspierając swoich podopiecznych. Jako potwierdzenie efektów pracy w 2019 roku otrzymała, podczas VII Gali Środowiska Studenckiego Kukucjusze 2019 AWF Katowice, wyróżnienie w kategorii Złote Serce.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/agnieszka-checinska-kopiec.62583341-9301-4ef3-a39b-5082f8e003e8.jpeg'
        },
        exam: [
            {
                question:
                    'Skąd między innymi wynikają zachowania agresywne u dzieci?',
                correct: 'a',
                answers: [
                    { key: 'a', value: 'Z przebodźcowania.' },
                    {
                        key: 'b',
                        value: 'Ze zbyt długiej zabawy.'
                    },
                    {
                        key: 'c',
                        value: 'Z powodu nudy.'
                    }
                ]
            }
        ],
        certificate: {
            title: 'Odkrywamy mocne strony dzieci. Sztuka wzmacniania',
            description:
                'za zdobycie wskazówek dotyczących efektywnego wspierania rozwoju dzieci i wzmacniania oraz pogłębiania ich szczególnych umiejętności podczas szkolenia',
            host: 'Agnieszkę Chęcińską-Kopiec'
        }
    },

    {
        uuid: '8ed02876-8f95-11ea-bc55-0242ac130003',
        cost: 1740,
        video_url: 'https://vimeo.com/415510486/4c08d0cd7e',
        receivers: ['teacher'],
        title:
            'Kształtowanie dobrych nawyków żywieniowych dzieci w wieku przedszkolnym',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/webinar-1.5d9d493b-ee35-4da4-ac46-07f63e2acece.jpeg',
        description:
            'Podczas szkolenia dowiesz się m.in.: jak powinny wyglądać pierwsze posiłki dziecka i od czego rozpocząć prawidłowe rozszerzanie diety już od najmłodszych lat. Poznaj produkty, których w żywieniu lepiej unikać i poznaj sposoby na kształtowanie zdrowych nawyków żywieniowych u dzieci w wieku przedszkolnym oraz uniknięcie podstawowych popełnianych przy tym błędów.',
        author: {
            name: 'Zuzanna Antecka',
            description:
                'Zuzanna Antecka jest dietetyczką i psycholożką, mamą Szpinakożercy, specjalistką od żywienia dzieci na każdym etapie życia. Jej misją jest pokazać wszystkim rodzicom, że każde dziecko może stać się małym smakoszem! Na co dzień prowadzi bloga pod nazwą “Szpinak robi bleee”. To właśnie tam dzieli się swoją wiedzą, pomysłami i przemyśleniami na temat żywienia.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/zuzanna-antecka.3cf3207b-e672-44fe-9758-8fba1f358ad1.jpeg'
        },
        exam: [
            {
                question:
                    'Jednym z największych błędów, jakie popełniają rodzice jest:',
                correct: 'a',
                answers: [
                    { key: 'a', value: 'zamykanie się w smakach dziecka.' },
                    {
                        key: 'b',
                        value:
                            'powtarzające się próby podawania danego produktu.'
                    },
                    {
                        key: 'c',
                        value: 'pozwalanie dziecku na samodzielność wyboru.'
                    }
                ]
            }
        ],
        certificate: {
            title:
                'Kształtowanie dobrych nawyków żywieniowych dzieci w wieku przedszkolnym',
            description:
                'za zdobycie wiedzy dotyczącej rozszerzania diety oraz kształtowania zdrowych nawyków żywieniowych u dziecka podczas szkolenia',
            host: 'Zuzannę Antecką'
        }
    },
    {
        uuid: '0dabfee0-9360-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/417115351/fdd875f07a',
        receivers: ['teacher'],
        title: 'Zaburzenia mowy u dzieci – profilaktyka i terapia logopedyczna',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/mowy.a67c3c86-4169-4825-a93c-d100dd939cf6.jpeg',
        description:
            'Zaburzeniom mowy u dzieci można przeciwdziałać. Wspólnie nauczymy się rozpoznawać je we wczesnym stadium, reagować na nie i wprowadzać odpowiednie leczenie. Skupimy się również na poznaniu prawidłowych etapów rozwoju dziecka, co pozwoli na szybką reakcję w przypadku, gdy przebiega on inaczej, niż powinien. Podpowiadamy również, na co zwrócić uwagę przy wyborze logopedy dla dziecka.',
        author: {
            name: 'Paulina Mistal',
            description:
                'Logopeda,  naukowiec, organizatorka wielu akcji społecznych o zasięgu ogólnokrajowym, współzałożycielka komitetu społecznego na rzecz ustawy o zawodzie logopedy, członek organizacji logopedycznych. Prowadzi na Facebooku znany profil pod nazwą Pani Logopedyczna, na którym dzieli się swoją wiedzą i doświadczeniem.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/paulina-mistal.88099112-5648-401f-aa86-a603972f67c8.jpeg'
        },
        exam: [
            {
                question: 'Czy zabawki interaktywne są lepsze od tradycyjnych?',
                correct: 'a',
                answers: [
                    {
                        key: 'a',
                        value:
                            'Nie - tradycyjne bardziej sprzyjają rozwojowi dziecka.'
                    },
                    {
                        key: 'b',
                        value: 'Tak, ponieważ angażują pełnię zmysłów dziecka.'
                    },
                    {
                        key: 'c',
                        value: 'Są na równi pod względem jakości dla rozwoju.'
                    }
                ]
            }
        ],
        certificate: {
            title:
                'Zaburzenia mowy u dzieci – profilaktyka i terapia logopedyczna',
            description:
                'za zdobycie wiedzy dotyczącej prawidłowego rozwoju aparatu mowy oraz rozpoznawania i reagowania na symptomy zaburzeń mowy u dzieci',
            host: 'Paulinę Mistal'
        }
    },
    {
        uuid: '894f0b8e-cd88-11ea-87d0-0242ac130003',
        video_url: 'https://vimeo.com/441257241/a604556d42',
        receivers: ['principal'],
        title: 'Zarządzanie żłobkiem od podstaw – o czym trzeba pamiętać?',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/zarzadzanie-zlobkiem-od-podstaw.1f265eb6-ef25-4c00-b143-9b425dbb4655.jpeg',
        description:
            'Wraz z prelegentką analizujemy krok po kroku procedurę zakładania własnej placówki - co wziąć pod uwagę zanim się zdecydujmy, jak znaleźć idealny lokal i jakich przeszkód możemy się spodziewać. Rozmawiamy również o dotacjach oraz planowaniu budżetu dla swojego żłobka.',
        author: {
            name: 'Magdalena Łuszcz',
            description:
                'swoja przygodę z edukacją zaczęła jako nauczyciel w grupie maluszków. Ukończyła m.in.: pedagogikę przedszkolną i wczesnoszkolną, specjalną oraz zarządzanie w oświacie. Obecnie jest dyrektorem Niepublicznego Żłobka i Przedszkola Hutniczek w Krakowie oraz Publicznego Przedszkola Miś Krzyś w Warszawie. Wcześniej była dyrektorem dwóch innych warszawskich placówek oraz nauczycielem zarówno tam, jak i w Krakowie.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/magdalena-luszcz.144d2b27-12d5-41b7-bc1a-615cd69d1d88.jpeg'
        }
    },
    {
        uuid: '894f0d96-cd88-11ea-87d0-0242ac130003',
        video_url: 'https://vimeo.com/440264525/293fd93a98',
        receivers: ['principal'],
        title: 'Dokumentacja w żłobku – RODO, rekrutacja i wiele innych',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/dokumentacja-w-zlobku.17700c55-6db9-41f2-ac2c-7cc299dac735.jpeg',
        description:
            'Prelegentka przedstawia szczegółowe informacje dotyczące ochrony danych osobowych w żłobku, oraz wybrane zagadnienia związane z rekrutacją pracowników. Wszystkie informacje zebraną są na prezentacji, która pomoże utrwalić zebrane informacje.',
        author: {
            name: 'Ewelina Pernet-Szóstak',
            description:
                'właścicielka Kancelarii Adwokackiej, która świadczy pomoc prawną dla osób fizycznych oraz przedsiębiorstw z zakresu: prawa cywilnego, prawa handlowego, prawa gospodarczego, prawa administracyjnego oraz prawa karnego. Posiada duże doświadczenie związane z dokumentacjami i ich szczegółowym przygotowaniem.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/ewelina-pernet-szostak.d752f96d-e87d-4f61-a7d5-e9207fac17a6.jpeg'
        }
    },
    {
        uuid: '894f0e90-cd88-11ea-87d0-0242ac130003',
        video_url: 'https://vimeo.com/441262378/9318926ba1',
        receivers: ['principal'],
        title: 'Wymogi techniczne żłobka oraz przygotowanie do kontroli',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/wymogi-techniczne-zlobka.4184ecce-7f27-455c-b361-2c3f74048716.jpeg',
        description:
            'W trakcie spotkania skupiamy się na wymaganiach technicznych lokalu pod żłobek oraz tych związanych z jego wyposażeniem i renowacjami. Prelegent dzieli się swoim doświadczeniem związanym z kontrolami przeprowadzanymi w placówce i radzi, jak się do nich dobrze przygotować.',
        author: {
            name: 'Piotr Góralczyk',
            description:
                'ukończył kierunek Zarządzanie Oświatą na Uniwersytecie Warszawskim. Od 5 lat prowadzi przedszkole, posiada również żłobek i szkołę podstawową w nurcie Montessori. Wraz z żoną stworzył miejsce, w którym każde dziecko można nauczyć się odkrywać swoje zainteresowania i pasje.',
            image: ''
        }
    },
    {
        uuid: '881de678-9038-11ea-bb37-0242ac130002',
        cost: 1740,
        video_url: 'https://vimeo.com/415855982/edf53dc63c',
        receivers: ['principal'],
        title:
            'Jakie prawa przysługują dyrektorom oraz wychowawcom żłobków i przedszkoli w sytuacji zawieszenia działalności placówek?',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/webinar-.580d34d4-416b-497b-ba23-0b057b67c92e.jpeg',
        description:
            'Czego dowiesz się podczas szkolenia? Zobowiązania finansowe w trakcie zawieszenia działalności żłobków i przedszkoli - np. jak wygląda wypłata dotacji, wynagrodzeń dla pracowników. Czy praca zdalna jest obecnie obowiązkiem wychowawcy? Czy musi zgadzać się na pracę przed kamerą? Prawa dyrektora żłobka lub przedszkola, urlopy pracowników i wiele, wiele więcej!',
        author: {
            name: 'Aleksandra Kowalewska',
            description:
                'Aleksandra Kowalewska prowadzi własną Kancelarię Adwokacką w Krakowie. Jest absolwentką studiów prawniczych Wydziału Prawa i Administracji Uniwersytetu Jagiellońskiego oraz członkiem Krakowskiej Izby Adwokackiej.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/aleksandra-kowalewska.607099ce-8477-42da-a029-bb48a97a7320.jpeg'
        },
        exam: [
            {
                question:
                    'W jaki sposób dyrektor może wydawać nauczycielom polecenia związane z pracą zdalną?',
                correct: 'a',
                answers: [
                    { key: 'a', value: 'W każdym momencie i w każdej formie' },
                    {
                        key: 'b',
                        value: 'W każdym momencie, w formie pisemnej'
                    },
                    { key: 'c', value: 'W każdym momencie, w formie ustnej' }
                ]
            }
        ],
        certificate: {
            title:
                'Jakie prawa przysługują dyrektorom oraz wychowawcom żłobków i przedszkoli w sytuacji zawieszenia działalności placówek?',
            description:
                'za zdobycie wiedzy dotyczącej najnowszych przepisów regulujących prawa i obowiązki wychowawców żłobków i przedszkoli w pracy zdalnej podczas szkolenia',
            host: 'Aleksandrę Kowalewską'
        }
    },
    {
        uuid: '8ed02b00-8f95-11ea-bc55-0242ac130003',
        video_url: 'https://vimeo.com/415516631/69c49704bf',
        previewvideo_url: 'https://vimeo.com/416283659/7b080fec0a',
        conference: '8ed031cc-8f95-11ea-bc55-0242ac130003',
        title:
            'Edukacja zdalna – regulacje prawa oświatowego oraz ochrona praw autorskich',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/regulacje-prawa.567110bb-8e67-4d8e-b0ca-f2a7af764aaf.jpeg',
        description:
            'Podczas szkolenia z naszą prelegentką: Przybliżymy nowe regulacje prawa oświatowego w kontekście obecnej sytuacji wychowawców i dyrektorów. Otrzymasz podstawowe informacje dotyczące ochrony praw autorskich materiałów, które możesz wykorzystać w pracy zdalnej. Zastanowimy się nad kwestiami związanymi z RODO w sytuacji korzystania ze sprzętu prywatnego podczas pracy zdalnej.',
        author: {
            name: 'Aleksandra Kowalewsk (fundacja Prawo dla Mam)',
            description:
                'Aleksandra Kowalewska prowadzi własną Kancelarię Adwokacką w Krakowie. Jest absolwentką studiów prawniczych Wydziału Prawa i Administracji Uniwersytetu Jagiellońskiego oraz członkiem Krakowskiej Izby Adwokackiej.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/aleksandra-kowalewska.382ec7d0-572f-4c4b-9e51-9077706d6ce6.jpeg'
        },
        certificate: {
            title:
                'Edukacja zdalna – regulacje prawa oświatowego oraz ochrona praw autorskich',
            description:
                'za zdobycie wiedzy dotyczącej poruszanych regulacji prawa oświatowego, a także ochrony praw autorskich i wizerunku w pracy zdalnej podczas szkolenia',
            host: 'Aleksandrę Kowalewską'
        }
    },
    {
        uuid: '8ed02ed4-8f95-11ea-bc55-0242ac130003',
        video_url: 'https://vimeo.com/415520750/fa721e2444',
        previewvideo_url: 'https://vimeo.com/416283845/2421a85e6b',
        conference: '8ed031cc-8f95-11ea-bc55-0242ac130003',
        title:
            'Kluczowe kompetencje dyrektora oraz wychowawcy w dobie edukacji zdalnej',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/kluczowe-kompetencje.3f4601e3-fae8-4769-b584-40c55abd7c3d.jpeg',
        description:
            'Podczas szkolenia z naszą prelegentką: Rozważymy rozwiązania służące pracy zdalnej, które pozostają w zasięgu ręki każdego wychowawcy. Podpowiemy, jak szczegółowo zaplanować przebieg pracy zdalnej i jak się z niej efektywnie rozliczyć. Porozmawiamy o kluczowych kompetencjach, które są istotne podczas obowiązku edukacji zdalnej.',
        author: {
            name: 'Gabriela Fejkiel (Edu Fejkiel)',
            description:
                'Gabriela Fejkiel - trenerka, absolwentka pedagogiki przedszkolnej i wczesnoszkolnej, dyrektor ds. pedagogicznych w przedszkolu, edukator II stopnia Froebel.pl, magister pedagogiki przedszkolnej i wczesnoszkolnej, absolwentka studiów doktoranckich z pedagogiki na Dolnośląskiej Szkole Wyższej we Wrocławiu. ',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/gabriela-fejkiel.e1520dcc-2cc0-4c08-90d8-2adf25aa0c90.jpeg'
        },
        attachments: [
            'https://service-assets.api-livekid-prod.com/v2/assets/public/10_wskazowek_od_gabrieli_fejkiel.a5760048-1e3b-4536-9803-ae980bd49a23.pdf'
        ],
        certificate: {
            title:
                'Kluczowe kompetencje dyrektora oraz wychowawcy w dobie edukacji zdalnej',
            description:
                'za zdobycie wiedzy dotyczącej kluczowych kompetencji wychowawcy i dyrektora, a także szczegółowego planowania i organizowania pracy zdalnej podczas szkolenia',
            host: 'Gabrielę Fejkiel'
        }
    },
    {
        uuid: '8ed02ff6-8f95-11ea-bc55-0242ac130003',
        video_url: 'https://vimeo.com/415516230/c25703ca15',
        previewvideo_url: 'https://vimeo.com/416283764/10e2484fda',
        conference: '8ed031cc-8f95-11ea-bc55-0242ac130003',
        title:
            'Profilaktyka i wsparcie emocjonalne wychowawcy oraz dziecka w obliczu edukacji zdalnej',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/profilaktyka-wsparcie.ea72cd66-79db-48d9-9bfb-3f2a9378820e.jpeg',
        description:
            'Podczas szkolenia z naszą prelegentką: Poruszymy temat zdalnego przeprowadzania i udzielania pomocy psychologiczno-pedagogicznej. Podamy konkretne przykłady działań i zabaw, które pomogą dziecku uporać się z emocjami w tym trudnym czasie. Pomożemy wychowawcom znaleźć źródła wsparcia emocjonalnego, które pomoże w pogodzeniu wszystkich obowiązków.  ',
        author: {
            name: 'Joanna Węglarz',
            description:
                'Joanna Węglarz - psycholog, specjalista psychologii klinicznej, socjoterapeuta, trener. Ukończyła studia podyplomowe „Diagnoza i rehabilitacja neuropsychologiczna” prowadzonych na UMCS w Lublinie, na co dzień  pracuje w Centrum Rehabilitacji Ośrodku Wczesnej Interwencji w Gdyni oraz Gdańskim Ośrodku Pomocy Psychologicznej dla Dzieci i Młodzieży.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/agnieszka-gruszczynska.4c79b097-5391-43f8-be08-4315bb6e11b4.jpeg'
        },
        attachments: [
            'https://service-assets.api-livekid-prod.com/v2/assets/public/material_dodatkowy_od_joanny_weglarz.a621af5c-0d7b-4029-a9dd-446b1a8088d6.pdf'
        ],
        certificate: {
            title:
                'Profilaktyka i wsparcie emocjonalne wychowawcy oraz dziecka w obliczu edukacji zdalnej',
            description:
                'za uzyskanie wiedzy o wspieraniu emocji własnych oraz dziecka i służących temu narzędziach, a także udzielaniu pomocy psychologiczno-pedagogicznej podczas szkolenia',
            host: 'Joannę Węglarz'
        }
    },
    {
        uuid: '8ed030e6-8f95-11ea-bc55-0242ac130003',
        video_url: 'https://vimeo.com/415504979/082c072058',
        previewvideo_url: 'https://vimeo.com/416283722/801b12470b',
        conference: '8ed031cc-8f95-11ea-bc55-0242ac130003',
        title:
            'Technologie i programy do pracy zdalnej dla dyrektora i wychowawcy przedszkola',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/technologie-programy.aca23c41-611e-4bf4-af3c-75651e040b52.jpeg',
        description:
            'Podczas szkolenia z naszą prelegentką: Pomożemy przełamać się do pracy z kamerą na żywo oraz podpowiemy, jak podejść do tworzenia własnych materiałów video. Podamy konkretne przykłady programów służących do komunikacji, montażu, tworzenia grafik oraz innych materiałów. Pozostawimy wskazówki i przydatne pomysły, służące ułatwieniu i przyspieszeniu pracy zdalnej z komputerem lub telefonem.',
        author: {
            name: 'Agnieszka Gruszczyńska',
            description:
                'Agnieszka Gruszczyńska - od przeszło 10 lat związana z branżą kreatywną, posiada wykształcenie pedagogiczne. Zaangażowana w tworzenie komunikacji marek dla klientów, wcześniej w agencji KISS digital, obecnie w Interim Project Managers, gdzie pracuje jako Communication Specialist. Na co dzień koordynuje działania zespołu, prowadzi badania rynku i analizuje upodobania określonych grup docelowych, a także tworzy strategie marketingowe w oparciu o dobór najlepszych kanałów komunikacji i dostępnych narzędzi.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/agnieszka-gruszczynska.9d548d4e-0249-4505-936a-e7ac0596e3d1.jpeg'
        },
        attachments: [
            'https://service-assets.api-livekid-prod.com/v2/assets/public/skrzynka_z_narzedziami_dla_wychowawcy_pracujacego_zdalnie.f44e8b96-36dc-44ae-bee8-ed500b62120d.pdf'
        ],
        certificate: {
            title:
                'Technologie i programy do pracy zdalnej dla dyrektora i wychowawcy przedszkola',
            description:
                'za zapoznanie się z narzędziami do pracy zdalnej i możliwościami, jakie stwarzają programy do tworzenia materiałów, takich jak grafiki czy animacje podczas szkolenia',
            host: 'Agnieszkę Gruszczyńską'
        }
    },
    {
        uuid: '744e6f8e-99c3-11ea-bb37-0242ac130002',
        previewvideo_url: 'https://vimeo.com/420257832/e3205e7920',
        video_url: 'https://vimeo.com/420247600/e6e22c6b60',
        conference: '918009ee-99c0-11ea-bb37-0242ac130002',
        title: 'Rozwój myślenia twórczego',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/razwoj-myslenia-tworczego.5c8d7a61-98d4-4871-b6a0-7ac43e95cfeb.jpeg',
        description:
            'Część teoretyczna, w której zastanowimy się jak rozwijać myślenie twórcze, czym cechuje się człowiek uzdolniony twórczo oraz jaką rolę ma rozwijanie myślenia twórczego w kontekście terapii i grupy integracyjnej. Część praktyczna – metodyka twórcza (rozgrzewka, eksploracje, elaboracje transformacje), przykłady działań. Symptomy zaburzeń w zakresie sensoryki, przepisy na masy plastyczne.',
        author: {
            name: 'Monika Sobkowiak',
            description:
                'Monika Sobkowiak - nauczycielka przedszkola i neurologopedka. W edukacji nie lubii tego, że w niektórych jej względach wciąż słychać echo starej dydaktyki, przymusu, nauki na pamięć. Ceni możliwość wyboru. Zamiast przymusu wybiera budowanie wewnętrznej motywacji. Po godzinach prowadzi szkolenia, tworzy pomoce dydaktyczne, artykuły do czasopism i piszę książki, poradniki i przewodniki dla nauczycieli.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/monika-sobkowiak.916330f2-f2da-4def-9262-ef0121dc5ba9.jpeg'
        },
        attachments: [
            'https://service-assets.api-livekid-prod.com/v2/assets/public/rozwoj-myslenia-tworczego-prezentacja.a3773a41-b69a-435f-a0a4-a8ec2dde81c9.pdf',
            'https://service-assets.api-livekid-prod.com/v2/assets/public/materialy-od-pani-moni.a7f30847-92fb-489f-9d41-deff8ad9c897.pdf'
        ],
        certificate: {
            title: 'Rozwój myślenia twórczego',
            description:
                'za zdobycie wiedzy dotyczącej rozwoju twórczego myślenia u dzieci oraz pozyskanie praktycznych inspiracji działań wspierających ten rozwój podczas szkolenia',
            host: 'Monikę Sobkowiak'
        }
    },
    {
        uuid: '9346e8f2-9a8c-11ea-bb37-0242ac130002',
        video_url: 'https://vimeo.com/420613670/7f76f46d84',
        previewvideo_url: 'https://vimeo.com/420630291/9409cc7531',
        conference: '918009ee-99c0-11ea-bb37-0242ac130002',
        title: 'Matematyka w przedszkolu',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/matematyka-w-przedszkolu.e86cb2b8-5a1c-496b-93e4-da619a8cd5f6.jpeg',
        description:
            'Nauczanie matematyki w przedszkolu – rozwój umiejętności matematycznych. Trudności edukacyjne: praktyczne sposoby postępowania – przykłady ćwiczeń. Kreatywne sposoby na naukę matematyki, zabawy i ćwiczenia wspierające.',
        author: {
            name: 'Aneta Szostak-Sulewska',
            description:
                'Aneta Szostak-Sulewska - z wykształcenia jest oligofrenopedagogiem, certyfikowanym praktykiem metody TOMATISA, trenerem profilaktyki pogryzień, certyfikowanym specjalistą- kynoterapeutą Polskiego Towarzystwa Kynoterapeutycznego, terapeutą rodzin. Od niedawna pełni także funkcję dziekana Wydziału Zamiejscowego WSH TWP w Szczecinie. Prowadzi stronę Kapelusz z Kwiatami, którą tworzy z myślą o nauczycielach.',
            image:
                'https://service-assets.api-livekid-prod.com/v1/assets/public/aneta-szostak-sulewska.a70ea1ad-b2fa-4cfa-b8ac-06e2b53ad7c7.jpeg'
        },
        attachments: [
            'https://service-assets.api-livekid-prod.com/v2/assets/public/materialy_pomocnicze_wspierajace_zabawy_w_domu.49383f38-a8e0-46dc-8771-d74f1fc4acce.pdf',
            'https://service-assets.api-livekid-prod.com/v2/assets/public/wierszyki_i_wyliczanki_od_anety_szostak_sulewskiej.953a9f0c-2d88-4b45-a165-0becb7b2e79c.pdf'
        ],
        certificate: {
            title: 'Matematyka w przedszkolu',
            description:
                'za pozyskanie inspiracji oraz wiedzy dotyczącej sposobów na kreatywne rozwijanie umiejętności matematycznych dziecka podczas szkolenia',
            host: 'Anetę Szostak-Sulewską'
        }
    },
    {
        uuid: '81294444-9b45-11ea-bb37-0242ac130002',
        video_url: 'https://vimeo.com/420992695/5f80362d43',
        previewvideo_url: 'https://vimeo.com/421009884/41dbbd6a99',
        conference: '918009ee-99c0-11ea-bb37-0242ac130002',
        title: 'Jak kreatywnie uczyć języka angielskiego w przedszkolu?',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/kreatywny-jezyk-angielski.dc5b928d-a877-4d81-8d7a-986ca9ad4d37.jpeg',
        description:
            'Kreatywny język angielski – od teorii do praktyki, czyli jak zachęcić dzieci do nauki i zainteresować językiem. Pomysły i inspiracje do wartościowych zajęć związanych z nauką języka angielskiego. Aktywne czytanie w nauce języka angielskiego – propozycje lektur i wykorzystania ich w przedszkolu.',
        author: {
            name: 'Marysia Bursche',
            description:
                'Marysia Bursche - z wykształcenia jest magistrem filologii romańskiej, jednak już od ponad dekady zajmuje się nauczaniem języka angielskiego w grupach przedszkolnych, a od ponad 6 lat prowadzi bloga Head Full of Ideas, adresowanego do innych nauczycieli. Jako jedna z pierwszych osób w Polsce postanowiła przekazywać innym swoją wiedzę i pomysły właśnie za pośrednictwem bloga. Znajdują się na nim  setki wpisów, wskazówki, porady, inspiracje i gotowe rozwiązania na zajęcia oraz darmowe materiały.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/marysia-bursche.cd25435c-5314-43a3-bab8-e0dcae848bf3.jpeg'
        },
        attachments: [
            'https://service-assets.api-livekid-prod.com/v2/assets/public/-pomyslow-od-marysi.6d175577-c39a-4bc2-b062-261970ac6fa1.pdf'
        ],
        certificate: {
            title: 'Jak kreatywnie uczyć języka angielskiego w przedszkolu?',
            description:
                'za poszerzenie warsztatu dydaktycznego o konkretne zabawy i sposoby na nauczanie języka angielskiego w przedszkolu podczas szkolenia',
            host: 'Marysię Bursche'
        }
    },
    {
        uuid: 'a93020a2-9c08-11ea-bb37-0242ac130002',
        video_url: 'https://vimeo.com/421653501/7f006a3a94',
        previewvideo_url: 'https://vimeo.com/421523616/05fc6dbb7a',
        conference: '918009ee-99c0-11ea-bb37-0242ac130002',
        title: 'Warsztaty muzyczno-ruchowe',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/warsztaty-muzyczno-ruchowe.3b5594fc-2843-4832-a026-325163a550b5.jpeg',
        description:
            'Rozwój kreatywności w grupie przedszkolnej poprzez zabawy muzyczno-ruchowe. Konkretne propozycje zabaw z wykorzystaniem muzyki, ruchu i zabawy. Praktyczne inspiracje dla wychowawców przedszkola – piosenki, wskazówki do zajęć itp.',
        author: {
            name: 'Monika Kluza',
            description:
                'Monika Kluza - instruktorka warsztatów muzyczno-teatralnych. Autorka bajek, wierszy, opowiadań i piosenek dla dzieci. Laureatka wielu konkursów poezji śpiewanej. Właściciel Centrum Edukacji Artystycznej Muzylek Moni. Organizuje i prowadzi autorskie warsztaty doskonalące dla nauczycieli szkół i przedszkoli z wykorzystaniem idei Carla Orffa. Propaguje amerykański system Chroma Notes®, wykorzystujący paletę kolorów do kodowania dźwięków umożliwiających grę na tęczowych instrumentach (m.in. Boomwwhackers).',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/monika-kluza.22215c6b-2c1d-4892-931c-0b079b1c6bd2.jpeg'
        },
        attachments: [
            'https://service-assets.api-livekid-prod.com/v2/assets/public/dodatek-od-moniki-kluzy.8a5d60aa-93c8-4ef6-b81c-0d490fd708fd.pdf'
        ],
        certificate: {
            title: 'Warsztaty muzyczno-ruchowe',
            description:
                'za zdobycie wiedzy dotyczącej roli muzyki w rozwoju dziecka oraz praktycznych inspiracji dotyczących prowadzenia zajęć ruchowych podczas szkolenia',
            host: 'Monikę Kluzę'
        }
    },
    // IV CONFERENCE
    {
        uuid: '70d6e3cc-a5a8-11ea-bb37-0242ac130002',
        livestreamvideo_url: 'GtgXNASJpZA',
        cost: 2749,
        oldCost: 3749,
        previewPlaceholder:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/miniatura-sylwia-anderson-hanney.e56111d8-3705-4831-b0c3-72f9adfd0a9c.jpeg',
        conference: '38c73e1e-a5a8-11ea-bb37-0242ac130002',
        title: 'Pozytywna Dyscyplina w przedszkolu',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/pozytywna-dyscyplina-w-przedszkolu.91c9fe77-9faf-4921-9c98-003a706a35dc.jpeg',
        customDescription: `
		<h2>
			<ul>
				<li>22.06.2020 | 18:00</li>
				<li>Założenia i filary Pozytywnej Dyscypliny, przydatne w jej wprowadzaniu</li>
				<li>Wspieranie naturalnego potencjału dzieci, ich talentów oraz mocnych stron</li>
				<li>Narzędzia Pozytywnej Dyscypliny służące rozwiązywaniu codziennych trudności</li>
			</ul>
		</h2>`,
        author: {
            name: 'Sylwia Anderson-Hanney',
            description:
                'Jest profilaktykiem społecznym oraz jedynym w Polsce certyfikowanym trenerem Pozytywnej Dyscypliny dla rodziców oraz nauczycieli. Jako członek Positive Discipline Association dba o merytorykę i jakość przeprowadzanych w Polsce warsztatów i szkoleń. Specjalizuje się w pracy z rodziną, w której wykorzystuje wiedzę i umiejętności pedagoga, terapeuty, coacha oraz mediatora.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/sylwia-anderson-hanney.a0ebcbff-c804-4278-977c-2a42a4e0764c.jpeg'
        },
        attachments: [
            'https://service-assets.api-livekid-prod.com/v2/assets/public/budowanie_poczucia_wlasnej_wartosci.c9984c2e-6bab-4cfc-b987-345743d53a83.pdf',
            'https://service-assets.api-livekid-prod.com/v2/assets/public/roznice_pomiedzy_pochwala_a_zacheta.08cc7006-bd5c-48d0-8e9e-185336d88c8a.pdf',
            'https://service-assets.api-livekid-prod.com/v2/assets/public/uprzejmy_i_stanowczy.b37b1ef3-7bb9-4754-8f24-c58e82e0ae0a.pdf',
            'https://service-assets.api-livekid-prod.com/v2/assets/public/karta_pracy_-_uprzejmy_i_stanowczy.b65150de-dfd1-4a1a-ac9a-af99c9e4eb5c.pdf',
            'https://service-assets.api-livekid-prod.com/v2/assets/public/pochwala_-_zacheta.79799e53-120d-4f8f-b30a-718755787292.jpeg',
            'https://service-assets.api-livekid-prod.com/v2/assets/public/polecenia_na_pytania_-_cwiczenie.50dffdfa-5386-45f2-b462-899bba6dd409.docx'
        ],
        certificate: {
            title: 'Pozytywna Dyscyplina w przedszkolu',
            description:
                'za zdobycie kompleksowej wiedzy związanej z założeniami i narzędziami służącymi zastosowaniu Pozytywnej Dyscypliny w przedszkolu podczas szkolenia',
            host: 'Sylwię Anderson-Hanney'
        }
    },
    {
        uuid: '70d6e8fe-a5a8-11ea-bb37-0242ac130002',
        livestreamvideo_url: '98cpgt68K2o',
        cost: 2749,
        oldCost: 3749,
        previewPlaceholder:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/miniatura-joanna-i-beata.a6930a09-aec7-493a-ae0c-cadcdcab1a43.jpeg',
        conference: '38c73e1e-a5a8-11ea-bb37-0242ac130002',
        title: 'Pozytywny wpływ aktywności ruchowej na dziecko',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/pozytywny-wplyw-aktywnosci-ruchowej-na-dziecko.c3fab9e0-7eec-4bbf-a7e0-5f3cd7060740.jpeg',
        customDescription: `
			<h2>
				<ul>
					<li>23.06.2020 | 18:00</li>
					<li>Budowanie relacji oraz modelowanie kompetencji psychospołecznych przez ruch i muzykę</li>
					<li>Wychowanie w aktywności ruchowej: skutki, założenia, pomysły i efekty</li>
					<li>Praktyczne inspiracje do prowadzenia zajęć muzyczno-ruchowych</li>
				</ul>
			</h2>`,
        author: {
            name: 'Joanna Bąk, Beata Kaczor',
            description: `<b>Joanna Bąk</b> - współzałożycielka Akademii Majki Jeżowskiej. Jest pedagogiem tańca i rozwoju dzieci oraz młodzieży, z praktyki i doświadczenia od 10 lat, z wykształcenia od 8 lat. Prowadzi Szkołę Tańca Fokus, gdzie uczy nie tylko tańca, ale również wychowuje dzieci poprzez połączenie ciała (ruchu), duszy (emocji), umysłu (myśli). Z wykształcenia jest nauczycielem przedszkolnym, animatorem kultury i arteterapeutą. Tańczy od ponad 30 lat.
				Jest również Fundatorką i wiceprezesem Fundacji Fokus dzieciom.<br /><br />
				<b>Beata Kaczor</b> - jest praktykiem psychologii budowania relacji i trenerem kompetencji psychospołecznych, trenerem mentalnym w zespole Jakuba B. Bączka oraz trenerem mentalnym w Szkole Tańca Fokus. Pod czujnym okiem Jacka Santorskiego ukończyła Akademię Psychologii Przywództwa na Politechnice Warszawskiej. Prowadzi swoją autorską Szkołę Trenerów Biznesu oraz Szkołę Trenerów Kompetencji Psychospołecznych, gdzie daje doświadczać nauczycielom przedszkolnym i szkolnym, jak budować relacje z dziećmi i jak dzięki temu pozwalać im się uczyć inaczej.`,
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/joanna-bak-i-beata-kaczor.b123293d-cbb1-476e-8e9c-b2d0d9915f76.jpeg'
        },
        attachments: [
            'https://service-assets.api-livekid-prod.com/v2/assets/public/wyzwanie-konferencja-livekid.5670cc5c-3097-4a1f-a61a-96346c7fd44b.pdf'
        ],
        certificate: {
            title: 'Pozytywny wpływ aktywności ruchowej na dziecko',
            description:
                'za poznanie wpływu ruchu i muzyki na modelowanie kompetencji psychospołecznych przez ruch i muzykę oraz zdobycie praktycznych inspiracji podczas szkolenia',
            host: 'Joannę Bąk i Beatę Kaczor'
        }
    },
    {
        uuid: '70d6e6d8-a5a8-11ea-bb37-0242ac130002',
        livestreamvideo_url: 'KpxKAMDYA14',
        cost: 2749,
        oldCost: 3749,
        previewPlaceholder:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/miniatura-agnieszka-checinska-kopiec.3107e9e1-c829-41d5-b338-9dbccd873a47.jpeg',
        conference: '38c73e1e-a5a8-11ea-bb37-0242ac130002',
        title: 'Warsztaty minimediacji w przedszkolu',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/warsztaty-minimediacj--w-przedszkolu.c75a9dd5-7a8b-4ee1-8e8d-49de5860808d.jpeg',
        customDescription: `
			<h2>
				<ul>
					<li>24.06.2020 | 18:00</li>
					<li>Jak nauczyć się aktywnie słuchać i rozumieć potrzeby dzieci?</li>
					<li>Jak za pomocą minimediacji towarzyszyć dzieciom w rozwiązywaniu problemów?</li>
					<li>Narzędzia i techniki służące do prowadzenia minimediacji w przedszkolu</li>
				</ul>
			</h2>`,
        author: {
            name: 'Agnieszka Chęcińska-Kopiec',
            description:
                'Nauczyciel akademicki, akredytowany praktyk tutoringu oraz certyfikowany edukator pozytywnej dyscypliny rodziców oraz nauczycieli, edukator self-reg. Pracuje jako nauczyciel akademicki (od 2007 roku); wdraża założenia tutoringu dbając o rozwój i wspierając swoich podopiecznych. Jako potwierdzenie efektów pracy w 2019 roku otrzymała, podczas VII Gali Środowiska Studenckiego Kukucjusze 2019 AWF Katowice, wyróżnienie w kategorii Złote Serce.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/agnieszka-checinska-kopiec.62583341-9301-4ef3-a39b-5082f8e003e8.jpeg'
        },
        attachments: [
            'https://service-assets.api-livekid-prod.com/v2/assets/public/minimediacje.e534cc15-26c2-4467-9bf7-a0d1dd3d4456.pdf'
        ],
        certificate: {
            title: 'Warsztaty minimediacji w przedszkolu',
            description:
                'za zdobycie umiejętności prowadzenia minimediacji z dziećmi w sytuacjach trudnych oraz konfliktowych celem mądrego rozwiązywania problemów podczas szkolenia',
            host: 'Agnieszkę Chęcińska-Kopiec'
        }
    },
    {
        uuid: '70d6e5e8-a5a8-11ea-bb37-0242ac130002',
        video_url: 'https://vimeo.com/433948782/ea86cf89c3',
        cost: 2749,
        oldCost: 3749,
        previewPlaceholder:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/miniatura-joanna-steinke-kalembka.b14c876c-3c75-4a04-a77c-b965ec8f201d.jpeg',
        conference: '38c73e1e-a5a8-11ea-bb37-0242ac130002',
        title: 'Dziecięce emocje w praktyce. Jak rozwijać samoregulację?',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/dzieciece-emocje-w-praktyce-jak-rozwijac-samoregulacje.add32c36-3ad4-487c-8166-e5e012adb562.jpeg',
        customDescription: `
			<h2>
				<ul>
					<li>25.06.2020 | 18:00</li>
					<li>Samoregulacja dla dzieci w wieku przedszkolnym – jak ją rozwijać?</li>
					<li>Jak działają dziecięce emocje i jak wspomagać ich przeżywanie.</li>
					<li>Praktyczne sposoby na pomoc dziecku w zrozumieniu swoich emocji.</li>
				</ul>
			</h2>`,
        author: {
            name: 'Joanna Steinke-Kalembka',
            description:
                'Psycholog, psychoterapeutka w trakcie procesu certyfikacji, trenerka umiejętności psychospołecznych. Zawodowo i życiowo zafascynowana psychologią i drugim człowiekiem. W swojej pracy psychoterapeutycznej opiera się mocno na terapii poznawczo-behawioralnej. Od kilku lat prowadzi swoją prywatną praktykę psychologiczną w Toruniu. Prowadzi również warsztaty i szkolenia psychologiczne. Jest założycielką portalu www.edukowisko.pl, na którym można znaleźć jej artykuły psychologiczne i rozwojowe.',
            image:
                'https://service-assets.api-livekid-prod.com/v2/assets/public/joanna-steinke-kalembka.ddfc2d87-d8ff-4dde-88af-2b1057a679cd.jpeg'
        },
        attachments: [
            'https://service-assets.api-livekid-prod.com/v2/assets/public/1-kart-zabaw-wspierajacych-regulacje-emocji.bc0211e2-4606-4616-865c-64dd0fb89f39.pdf'
        ],
        certificate: {
            title: 'Dziecięce emocje w praktyce. Jak rozwijać samoregulację?',
            description:
                'za poszerzenie wiedzy dotyczącej rozwoju i zrozumienia emocji dziecka oraz pozyskanie praktycznych informacji dotyczących samoregulacji tych emocji podczas szkolenia',
            host: 'Joannę Steinke-Kalembka'
        }
    }
]
export const conferences = [
    {
        uuid: '38c73e1e-a5a8-11ea-bb37-0242ac130002',
        title: 'E-konferencja LiveKid "Pozytywni w edukacji"',
        cost: 5749,
        oldCost: 7749,
        subtitle: 'Edycja IV',
        description:
            'E-konferencja LiveKid powraca w kolejnej edycji, by dostarczyć Ci jeszcze więcej inspiracji i wiedzy związanej z Twoją codzienną pracą! Tym razem towarzyszyć nam będzie hasło “Pozytywni w edukacji”. Poniżej sprawdzisz, co przygotowali dla Ciebie nasi nowi prelegenci! Dodatkowo udział w naszej e-konferencji online jest potwierdzany certyfikatem udziału. ',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/iv-e-konferencja-livekid.370d44fa-e5f4-4b12-a4ca-9bb33689eecf.jpeg',
        webinars: [
            '70d6e3cc-a5a8-11ea-bb37-0242ac130002',
            '70d6e8fe-a5a8-11ea-bb37-0242ac130002',
            '70d6e6d8-a5a8-11ea-bb37-0242ac130002',
            '70d6e5e8-a5a8-11ea-bb37-0242ac130002'
        ]
    },
    {
        uuid: '918009ee-99c0-11ea-bb37-0242ac130002',
        title: 'E-konferencja LiveKid "Kreatywni w edukacji"',
        cost: 7740,
        subtitle: 'Edycja III',
        description:
            'Nadchodzi czas, w którym powoli przygotowujemy się do powrotu do żłobków i przedszkoli. Dlatego tym razem w ramach wsparcia obraliśmy sobie za cel dostarczenie Ci wartościowej dawki kreatywnych inspiracji do pracy. Nasi prelegenci są gotowi, by podzielić się z Tobą wiedzą zarówno teoretyczną, jak i praktyczną! Jak zawsze przewidzieliśmy również imienne certyfikaty uczestnictwa w szkoleniach, oraz materiały dodatkowe od naszych ekspertów.',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/-ekonferencja-header.832ca918-e16b-4fc3-97cd-758769ddc2d8.jpeg',
        webinars: [
            '744e6f8e-99c3-11ea-bb37-0242ac130002',
            '9346e8f2-9a8c-11ea-bb37-0242ac130002',
            '81294444-9b45-11ea-bb37-0242ac130002',
            'a93020a2-9c08-11ea-bb37-0242ac130002'
        ]
    },
    {
        uuid: '8ed031cc-8f95-11ea-bc55-0242ac130003',
        title: 'II E-konferencja LiveKid "Zdalni w edukacji"',
        cost: 7740,
        subtitle: 'Edycja II',
        description:
            'Edukacja zdalna stawia przed nami niemałe wyzwania. Aby pomóc z jej organizacją, zdecydowaliśmy się na drugą edycję konferencji dla żłobków i przedszkoli. Zależy nam na tym, aby każdy dyrektor i wychowawca mógł uzyskać informacje w interesującym go zakresie - prawa oświatowego, organizacji i motywacji do edukacji zdalnej, wsparcia emocjonalnego czy pracy z technologią i programami online. W ramach każdego webinaru przewidzieliśmy również imienne certyfikaty udziału.',
        thumbnail:
            'https://service-assets.api-livekid-prod.com/v2/assets/public/ekonferencja-header.fe20846c-2592-4521-bc00-7f55a64f197e.jpeg',
        webinars: [
            '8ed02b00-8f95-11ea-bc55-0242ac130003',
            '8ed02ed4-8f95-11ea-bc55-0242ac130003',
            '8ed02ff6-8f95-11ea-bc55-0242ac130003',
            '8ed030e6-8f95-11ea-bc55-0242ac130003'
        ]
    }
]
export function getConference(webinar) {
    return conferences.find(c => c.webinars.includes(webinar.uuid))
}
export function getWebinarsByType(type) {
    if (!type) {
        return allWebinars.filter(w => !w.conference)
    }
    return allWebinars.filter(
        w => !w.conference && w.types && w.types.includes(type)
    )
}
